import { useQuery } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import productDetails from 'src/repositories/productDetails';
import { checkAllPropertiesNull } from 'src/utils/helper';

const BASIC_INFO_PATH = '/price/finished-product/information';

const useProductInformationMultiple = (
  listProductId,
  isProductFinished,
  shouldFetchProductsInfor,
) => {
  const areAllPropertiesNull = checkAllPropertiesNull(listProductId);

  const { data, error } = useQuery<
    AxiosResponse<Response.ProductFinishedInfo>,
    AxiosError<Response.Error>
  >({
    queryKey: [BASIC_INFO_PATH, listProductId],
    enabled:
      !!isProductFinished && !areAllPropertiesNull && shouldFetchProductsInfor,
    queryFn: productDetails.getBasicInfo,
  });

  if (error) {
    return { productsInfor: [] };
  }
  return { productsInfor: data?.data?.items ?? [] };
};

export default useProductInformationMultiple;
